/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { ApOfficeMemberReportNotificationSetting } from '../model/apOfficeMemberReportNotificationSetting';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get Report Notification Setting for Office Member
 */
export const useGetApOfficeMemberReportNotificationSettingHook = () => {
  const getApOfficeMemberReportNotificationSetting =
    useCustomClient<ApOfficeMemberReportNotificationSetting>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApOfficeMemberReportNotificationSetting(
      {
        url: `/api/js/ap_office_member_report_notification_setting`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApOfficeMemberReportNotificationSettingQueryKey = () => {
  return [`/api/js/ap_office_member_report_notification_setting`] as const;
};

export const useGetApOfficeMemberReportNotificationSettingQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApOfficeMemberReportNotificationSettingQueryKey();

  const getApOfficeMemberReportNotificationSetting =
    useGetApOfficeMemberReportNotificationSettingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
      >
    >
  > = ({ signal }) =>
    getApOfficeMemberReportNotificationSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApOfficeMemberReportNotificationSettingQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
    >
  >
>;
export type GetApOfficeMemberReportNotificationSettingQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get Report Notification Setting for Office Member
 */
export const useGetApOfficeMemberReportNotificationSetting = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApOfficeMemberReportNotificationSettingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApOfficeMemberReportNotificationSettingSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
      >
    >,
    TError = ErrorType<
      UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
    >
  >(options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApOfficeMemberReportNotificationSettingQueryKey();

    const getApOfficeMemberReportNotificationSetting =
      useGetApOfficeMemberReportNotificationSettingHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
        >
      >
    > = ({ signal }) =>
      getApOfficeMemberReportNotificationSetting(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetApOfficeMemberReportNotificationSettingSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
      >
    >
  >;
export type GetApOfficeMemberReportNotificationSettingSuspenseQueryError =
  ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>;

/**
 * @summary Get Report Notification Setting for Office Member
 */
export const useGetApOfficeMemberReportNotificationSettingSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useGetApOfficeMemberReportNotificationSettingHook>
        >
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApOfficeMemberReportNotificationSettingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update Report Notification Setting for Office Member
 */
export const useUpdateApOfficeMemberReportNotificationSettingHook = () => {
  const updateApOfficeMemberReportNotificationSetting =
    useCustomClient<ApOfficeMemberReportNotificationSetting>();

  return (
    apOfficeMemberReportNotificationSetting: BodyType<ApOfficeMemberReportNotificationSetting>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateApOfficeMemberReportNotificationSetting(
      {
        url: `/api/js/ap_office_member_report_notification_setting`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: apOfficeMemberReportNotificationSetting,
      },
      options
    );
  };
};

export const useUpdateApOfficeMemberReportNotificationSettingMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useUpdateApOfficeMemberReportNotificationSettingHook>
      >
    >,
    TError,
    { data: BodyType<ApOfficeMemberReportNotificationSetting> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useUpdateApOfficeMemberReportNotificationSettingHook>
    >
  >,
  TError,
  { data: BodyType<ApOfficeMemberReportNotificationSetting> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateApOfficeMemberReportNotificationSetting =
    useUpdateApOfficeMemberReportNotificationSettingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useUpdateApOfficeMemberReportNotificationSettingHook>
      >
    >,
    { data: BodyType<ApOfficeMemberReportNotificationSetting> }
  > = (props) => {
    const { data } = props ?? {};

    return updateApOfficeMemberReportNotificationSetting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateApOfficeMemberReportNotificationSettingMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useUpdateApOfficeMemberReportNotificationSettingHook>
      >
    >
  >;
export type UpdateApOfficeMemberReportNotificationSettingMutationBody =
  BodyType<ApOfficeMemberReportNotificationSetting>;
export type UpdateApOfficeMemberReportNotificationSettingMutationError =
  ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >;

/**
 * @summary Update Report Notification Setting for Office Member
 */
export const useUpdateApOfficeMemberReportNotificationSetting = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useUpdateApOfficeMemberReportNotificationSettingHook>
      >
    >,
    TError,
    { data: BodyType<ApOfficeMemberReportNotificationSetting> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpdateApOfficeMemberReportNotificationSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
